import React from 'react';
import { compose } from 'ramda';
import STPaymentPoints from './StarTraveler/PaymentPoints.jsx'
import {STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import { connect } from 'react-redux';

const LoyaltyPaymentPoints = props => {
  const { type } = props;

   if (type === STAR_TRAVELER_CODE) {
    return (<STPaymentPoints  {...props} />);
  }

  return null;   
};
const mapStateToProps = (store) => {
  
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);
  return {
    loyalty,
    type: loyalty && loyalty.get("code"),
  }
};
  


export default compose(
  connect(mapStateToProps),
)(LoyaltyPaymentPoints);
